import { CommentV2 as CommentV2Type } from '~/lib/discussions/types';
import { Button } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useCommentV2 } from '~/lib/discussions/useCommentV2';
import { ReplyModalV2 } from './ReplyModalV2';
import useUser from '~/lib/user';
import { useModal } from '@appsumo/dorado-react';
import { useEventDispatch } from '~/lib/events';
import { PDPContext } from '~/lib/product/context';
import { useContext } from 'react';
import type { Deal } from '~/types/deal';
import { useUserStatus } from '~/hooks/userStatus';

export const ButtonsV2 = ({
  comment,
  mutateComment,
  isReview = false,
}: {
  comment: CommentV2Type;
  mutateComment: () => void;
  isReview?: boolean;
}) => {
  const dispatchEvent = useEventDispatch();
  const { deal }: { deal: Deal } = useContext(PDPContext);
  const { like, disableVoteBtn } = useCommentV2(comment, mutateComment);
  const { user } = useUser();
  const { userStatus } = useUserStatus(deal.id);
  const isEmailVerified = !!user?.email_verified;
  const isAuthenticated = !!user;
  const [showModal, hideModal] = useModal(
    () => (
      <ReplyModalV2
        deal={deal}
        hideModal={hideModal}
        comment={comment}
        type={isReview ? 'dealreview' : 'dealcomment'}
        mutateComment={mutateComment}
      />
    ),
    [],
  );

  const showModalAndEmit = () => {
    showModal();
    dispatchEvent('pdp:toggleBuyButton', true);
  };

  let showReplyButton = isAuthenticated && comment.level !== 2;

  if (isReview) {
    showReplyButton =
      (user?.is_staff || userStatus?.user_moderator) && comment.level === 0;
  }

  return (
    <div className="mt-4 flex justify-end gap-x-2 max-sm:flex-col">
      <Button
        tertiary
        size="small"
        onClick={isEmailVerified ? like : void 0}
        disabled={!isEmailVerified || disableVoteBtn}
      >
        <div className="flex items-center justify-center gap-x-1">
          <FontAwesomeIcon icon={faChevronUp} />
          <span>Helpful {comment.up_votes}</span>
        </div>
      </Button>
      {showReplyButton && (
        <Button
          className="max-sm:mt-2"
          size="small"
          onClick={() => showModalAndEmit()}
          disabled={!isEmailVerified}
        >
          Reply
        </Button>
      )}
    </div>
  );
};
